import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { VILLES, distanceKm } from "../data/villes";
import { HQ, RADIUS_KM } from "../components/espaces-verts/ZoneMap";
import { HANDY_RADIUS_KM, REGIONS } from "../components/ZoneIntervention";
import { MapPin, Leaf, Wrench, ArrowRight } from "lucide-react";

/** Index des pages villes : regroupées par région, avec pastilles espaces verts (40 km) / toutes mains (50 km). */
export default function Villes() {
  const byRegion = REGIONS.map((r) => ({ r, items: VILLES.filter((v) => v.region === r) })).filter((g) => g.items.length);
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Header solid />
      <main className="flex-1" data-testid="villes-page">
        <section className="max-w-6xl mx-auto px-5 pt-12 md:pt-16 pb-6">
          <p className="text-xs font-semibold tracking-[0.2em] text-brand uppercase mb-4 flex items-center gap-2"><MapPin size={14} /> Villes desservies</p>
          <h1 className="font-heading font-extrabold text-4xl sm:text-5xl text-neutral-900 leading-tight">Nettoyage B2B dans les métropoles du <span className="text-brand">Grand Nord</span></h1>
          <p className="text-neutral-600 mt-6 text-base md:text-lg max-w-2xl">Nos équipes de nettoyage interviennent dans toute la moitié nord de la France. Les petits travaux (homme toutes mains) sont proposés à moins de {HANDY_RADIUS_KM} km de Servins, les espaces verts à moins de {RADIUS_KM} km.</p>
        </section>
        <section className="max-w-6xl mx-auto px-5 pb-16 space-y-10">
          {byRegion.map(({ r, items }) => (
            <div key={r} data-testid={`villes-region-${r.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
              <h2 className="font-heading font-bold text-base md:text-lg text-neutral-900 mb-4">{r}</h2>
              <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
                {items.map((v) => {
                  const d = Math.round(distanceKm(HQ, v));
                  return (
                    <a key={v.slug} href={`/nettoyage/${v.slug}`} className="border border-neutral-200 rounded-xl px-4 py-3 flex items-center justify-between gap-3 hover:border-brand hover:shadow-sm transition-all" data-testid={`ville-link-${v.slug}`}>
                      <div><p className="font-semibold text-neutral-900">{v.nom}</p><p className="text-xs text-neutral-500">{v.dep} · {d} km</p></div>
                      <div className="flex items-center gap-1.5">
                        {d <= HANDY_RADIUS_KM && <span className="w-6 h-6 rounded-full bg-amber-100 text-amber-700 flex items-center justify-center" title="Homme toutes mains"><Wrench size={12} /></span>}
                        {d <= RADIUS_KM && <span className="w-6 h-6 rounded-full bg-emerald-100 text-emerald-700 flex items-center justify-center" title="Espaces verts"><Leaf size={12} /></span>}
                        <ArrowRight size={15} className="text-neutral-400" />
                      </div>
                    </a>
                  );
                })}
              </div>
            </div>
          ))}
          <p className="text-sm text-neutral-500">Votre ville n'est pas listée ? Nous couvrons l'ensemble du Grand Nord : <a href="/#devis" className="text-brand font-semibold hover:underline">demandez un devis</a>, nous vous répondons sous 24 h.</p>
        </section>
      </main>
      <Footer />
    </div>
  );
}
